import * as actions from './esg.actions';
import { DatesInterval, SortInfo } from '../../global/interfaces';
import { EsgDataResponse, EsgFilter } from './esg.models';

export interface State {
    loading: boolean;
    dates?: DatesInterval;
    data: EsgDataResponse;
    filter?: EsgFilter;
    sort: SortInfo;

}

export const initialState: State = {
    loading: false,
    dates: undefined,
    data: {
        esgData: [],
        esgDate: undefined
    },
    filter: {
        year: undefined,
        month: undefined
    },
    sort: {
        column: 'name',
        reverse: true
    }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.ActionTypes.LOAD_ESG_DATES:
            return {
                ...state,
                loading: true,
                dates: undefined, filter: { ...state.filter, month: undefined, year: undefined }
            };
        case actions.ActionTypes.LOAD_ESG_DATES_SUCCESS:
            return { ...state, loading: false, dates: action.payload };
        case actions.ActionTypes.LOAD_ESG_DATES_FAILED:
            return { ...state, loading: false };
        case actions.ActionTypes.LOAD_ESG:
            return { ...state, loading: true };
        case actions.ActionTypes.LOAD_ESG_SUCCESS:
            return { ...state, loading: false, data: { esgDate: action.payload.esgDate, esgData: action.payload.esgData } };
        case actions.ActionTypes.LOAD_ESG_FAILED:
            return { ...state, loading: false };
        case actions.ActionTypes.SET_ESG_YEAR_FILTER:
            return { ...state, filter: { ...state.filter, year: action.payload } };
        case actions.ActionTypes.SET_ESG_MONTH_FILTER:
            return { ...state, filter: { ...state.filter, month: action.payload } };
        case actions.ActionTypes.SET_ESG_SORT:
            return { ...state, sort: action.payload };
        case actions.ActionTypes.RESET_ESG_DATA:
            return initialState;
        default:
            return state;
    }
}
